// Clients will provide vimeo link.
// If vimeo link is https://vimeo.com/557230853/dcf7836b65
// then the vimeoId is 557230853, not the dcf..

import amgenVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/amgen.png'
import medartisVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/medartis.png'
import menariniVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/menarini.png'
import pfizerVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/pfizer.png'
import strykerVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/stryker.png'
import zimmerbiometVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/zimmerbiomet.png'
import gsk2VirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/gsk2.png'
import jnj2VirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/jnj2.png'

import videoThumbnail from '../../images/gallerium/onDemand/video-thumbnail.png'

export interface onDemandVideosType {
  vimeoId: string
  title: string
  thumbnail?: string
  /**
   * can be react routes, ie. /booths/1, /lobby
   * or external link, ie. https://something.com, mailto:hello@email.com
   */
  buttonUrl?: string
  buttonText?: string
}

const lunchBreakfastSymposiumVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '13',
    title: 'Video Title 1',
  },
  {
    vimeoId: '14',
    title: 'Video Title 2',
  },
]

const liveRecordedDay1: Array<onDemandVideosType> = [
  {
    vimeoId: '632804655',
    title: 'ICL 1 – Hip Arthroscopy',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '632802714',
    title: 'ICL 2 – Knee Realignment Procedures',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '632809846',
    title: 'Opening Ceremony',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '632810092',
    title: 'Plenary Lecture',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '632811578',
    title: 'Symposium 1 – Uncommon Knee Injuries',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '632808330',
    title: 'Lunch Symposium (Malex Medical / Arthrex)',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '632952573',
    title: 'Symposium 2 – Update on Meniscus Treatment',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '632929607',
    title: 'Symposium 3 – Cartilage Injuries',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '632947966',
    title: 'Sanusi Ghani Award Judging',
    thumbnail: videoThumbnail,
  },
]

const liveRecordedDay2: Array<onDemandVideosType> = [
  {
    vimeoId: '633665857',
    title: 'ICL 3 – Interventional Pain Management',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '633734656',
    title: 'ICL 4 – Shoulder Arthroplasty',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '633665857',
    title: 'Case Presentation 1',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '633667374',
    title: 'Breakfast Symposium (Malex Medical / Arthrex)',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '633649089',
    title: 'Symposium 4 – AC Joint',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '633652537',
    title: 'Symposium 4 - Rotator Cuff',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '633743383',
    title: 'Lunch Symposium (A. Menarini)',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '633662678',
    title: 'Symposium 5 – Patellofemoral Joint Instability',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '633657646',
    title: 'Azmi Abdul Latif Award Judging',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '633746196',
    title: 'Tea Symposium (Smith & Nephew)',
    thumbnail: videoThumbnail,
  },
]
const liveRecordedDay3: Array<onDemandVideosType> = [
  {
    vimeoId: '634265501',
    title: 'ICL 5 – Ankle Sprain: From Conservative to Surgery',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '634256323',
    title: 'ICL 6 – ACL Injury in Open Physeal Patients',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '634260404',
    title: 'Case Presentation 2',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '634257875',
    title: 'Symposium 6 – The Use of Orthobiologics in Sports Injuries',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '634256546',
    title: 'Crossfire: ACL Reconstruction – Do We Have To Wait?',
    thumbnail: videoThumbnail,
  },
  {
    vimeoId: '634255443',
    title: 'Closing Ceremony',
    thumbnail: videoThumbnail,
  },
]

export { liveRecordedDay1, liveRecordedDay2, liveRecordedDay3 }
